"use strict";import{QuickActions as i}from"./src/QuickActions.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-quick-actions",i);
//# sourceMappingURL=sp-quick-actions.js.map
